import { UserDataAiToolsAccessV2Type } from '@gql/ai-tools/graphql';
import { UserDataModel } from '@models/userData';
import { parseActiveSplitTags } from '@utils/splits';

export const userDataModel = (
  userData: UserDataAiToolsAccessV2Type
): UserDataModel => {
  const isUnlimited = userData?.wordBalance === 'UNLIMIT';

  return {
    userId: userData?.userId ? String(userData.userId) : '',
    isUserSubscribed: userData?.subscription === true,
    hasUserEverHadSubscription: userData?.hasUserEverHadSubscription === true,
    isInitialUserDataUpdated: true,
    clientHash: userData?.clientHash || '',
    useSafeCopywriting: userData?.useSafeCopywriting === true,
    hasPremiumAccess: userData?.isProFeatureAvailable === true,
    hasAiToolsAccess: userData?.hasAiToolsAccess === true,
    hasActiveSubscription: userData?.hasActiveSubscription === true,
    isAppInboxEnabled: userData?.isAppInboxEnabled === true,
    wordsBalance: {
      isUnlimited,
      left: isUnlimited ? Infinity : Number(userData?.wordBalance || '0'),
      total: Number(userData?.wordBalanceTotal || '0'),
    },
    isSplitEs38751: userData?.isSplitEs38751New === true,
    isSplitEs38799: userData?.isSplitEs38799New === true,
    isSplitEs38934: userData?.isSplitEs38934New === true,
    isSplitEs39088: userData?.isSplitEs39088New === true,
    isSplitEs39290: userData?.isSplitEs39290New === true,
    isSplitEs39123: userData?.isSplitEs39123New === true,
    isAgreeAutoUpgradeEs39123: userData?.isAgreeAutoUpgradeEs39123 === true,
    isSplitEs39222: userData?.isSplitEs39222New === true,
    activeSplitTags: parseActiveSplitTags(userData?.activeSplitTags),
    isTestUser: userData?.isTestUser === true,
    profile: {
      firstName: userData?.firstName || '',
      lastName: userData?.lastName || '',
      email: userData?.email || '',
      photoSrc: userData?.photoSrc || '',
    },
    reviewWidgets: {
      smartCustomerKey: userData?.smartCustomerFeedbackKey || null,
      trustpilotBusinessUnitId: userData?.trustpilotBusinessUnitId || null,
    },
  };
};
